import { render, staticRenderFns } from "./MassAdditionalActions.vue?vue&type=template&id=4852a53d&"
import script from "./MassAdditionalActions.vue?vue&type=script&lang=js&"
export * from "./MassAdditionalActions.vue?vue&type=script&lang=js&"
import style0 from "./MassAdditionalActions.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtnDropdown,QToggle});
